// extracted by mini-css-extract-plugin
module.exports = {"button":"NewGlobalAlert_button__18U8o","eventsSelector":"NewGlobalAlert_eventsSelector__31BRP","sponsorsLayoutBackground":"NewGlobalAlert_sponsorsLayoutBackground__3uIQs"};